export default {
    state: {
        subscriptionServices: [],
        subscribedServicesByConsumer: [],
        isLoading: false
    },
    mutations: {
        setSubscriptionServices (state, data) {
            state.subscriptionServices = data
        },
        startSubscriptionsLoading (state) {
            state.isLoading = true
        },
        stopSubscriptionsLoading (state) {
            state.isLoading = false
        },
        setSubscribedServicesByConsumer (state, data) {
            state.subscribedServicesByConsumer = data
        }
    },
    actions: {
        setSubscriptionServices ({ commit }, data) {
            commit('setSubscriptionServices', data)
        },
        startSubscriptionsLoading ({ commit }) {
            commit('startSubscriptionsLoading')
        },
        stopSubscriptionsLoading ({ commit }) {
            commit('stopSubscriptionsLoading')
        },
        setSubscribedServicesByConsumer ({ commit }, data) {
            commit('setSubscribedServicesByConsumer', data)
        }
    },
    getters: {
        subscriptionServices: (state) => state.subscriptionServices,
        subscribedServicesByConsumer: (state) => state.subscribedServicesByConsumer,
        isLoading: (state) => state.isLoading
    }
}
